import "../styles/MyTickets.css";
import { parseISO, format } from "date-fns";
import { useState, useEffect } from "react";

export const MyTickets = ({ handleModalContent, refreshTokenUserCheck }) => {
  const [tickets, setTickets] = useState([]);

  const getTickets = async () => {
    try {
      const response = await fetch((process.env.NODE_ENV === "production" ? "https://" : "http://") + process.env.REACT_APP_API_URL + "/api/ticket", {
        method: "GET",
        credentials: "include",
      });
      switch (response.status) {
        case 200:
          let tickets = await response.json();
          // parcea la fecha de creacion de cada ticket
          tickets.forEach((ticket) => {
            ticket.createdAt = format(
              parseISO(ticket.createdAt),
              "dd/MM/yyyy",
            );
          });
          setTickets(tickets);
          break;
        case 401:
          //Si el accesstoken expiró lo actualiza
          refreshTokenUserCheck();
          getTickets();
          break;
        case 403:
          const tokenError = await response.json();
          console.log("TokenError: ", tokenError);
          break;
        default:
          break;
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTickets();
  }, []);
  return (
    <>
      <div className="title-description">
        <h2>Mis Tickets</h2>
      </div>
      <ul className="ticket-list">
      {tickets.length === 0 && (<p className="empty-legend">No hay tickets</p>)}
        {tickets.map(({ id, name, productList, createdAt }) => {
          return (
            <li
              className={`item-list item-id-${id}`}
              key={id}
              onClick={() =>
                handleModalContent("TicketDetail", "", "", "", {
                  name,
                  products: productList,
                  createdAt,
                })
              }
            >
              <div>{name}</div>
              <div>{createdAt}</div>
            </li>
          );
        })}
      </ul>
    </>
  );
};
